import { Button, Card, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const ElectricalServicesModal = (props) => {
  const { t } = useTranslation();
  const title = t('electricalModalTitle');

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h1">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('electricalModalDesc')}</p>
        <Card className="px-4">
          <ul>
            <li>{t('electricalService1')}</li>
            <li>{t('electricalService2')}</li>
            <li>{t('electricalService3')}</li>
            <li>{t('electricalService4')}</li>
          </ul>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onHide(title)}>{t('getQuote')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ElectricalServicesModal;
